module.exports = __webpack_public_path__ + "assets/img/security-new.43341c67.svg";